module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iDWNp"))).then(() => parcelRequire('hEqeo'));